module.exports = __webpack_public_path__ + "img/page_paper_file_document_house_home_icon.b482a998.svg";